var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6026 9.67886C21.6001 7.11256 20.5795 4.65209 18.7648 2.83748C16.9502 1.02287 14.4896 0.00238277 11.9233 0C10.1291 0.017349 8.3738 0.525823 6.84809 1.47024C5.32237 2.41465 4.08448 3.75892 3.26876 5.35714C2.38334 7.15971 1.92262 9.23057 1.47605 11.2371C1.27419 12.1444 0.300049 15.5859 0.300049 15.5859H3.31677L2.04947 20.8033H8.46004L7.74005 24.0004H20.4481V14.2654C21.2065 12.856 21.6032 11.2803 21.6026 9.67972V9.67886ZM19.008 22.5596H9.54476L9.9382 20.8024H13.4713V19.3624H3.87134L5.13604 14.1424H2.25605C2.48191 13.3119 2.67604 12.4457 2.87533 11.5431C3.3039 9.62314 3.74662 7.63371 4.55534 5.98457C5.25157 4.62579 6.30674 3.4837 7.60627 2.6823C8.9058 1.8809 10.4 1.4508 11.9268 1.43871C14.1112 1.4411 16.2055 2.30993 17.7502 3.85458C19.2948 5.39923 20.1637 7.49354 20.166 9.678C20.1339 11.15 19.7363 12.591 19.0089 13.8711C19.0089 13.8711 19.0089 19.8617 19.0089 22.5591L19.008 22.5596Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.288c1e19.svg";
export { ForwardRef as ReactComponent };